import { render, staticRenderFns } from "./SingleUserAssignments.vue?vue&type=template&id=120d98d8&scoped=true&"
import script from "./SingleUserAssignments.vue?vue&type=script&lang=js&"
export * from "./SingleUserAssignments.vue?vue&type=script&lang=js&"
import style0 from "./SingleUserAssignments.vue?vue&type=style&index=0&id=120d98d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120d98d8",
  null
  
)

export default component.exports